<template>
    <div class="bundleThumbnail handCursor" @click="getBundle" :class="{bundleTNinEditMode: $parent.$parent.editMode}">
        <div class="bundleHeaderThumbnail has-text-left">
             <div class="is-inline-block has-text-coolGreen handCursor is-size-5 " >&nbsp;<b>::</b></div><span class="is-size-6"><b> {{item.listName}}</b></span>
        </div>
   
            <div class="bundleTNimg">
               <img :src="item.imgs[0].img" @error="imgError(0)"/>
            </div>
            <div class="bundleTNimg">
               <img :src="item.imgs[1].img" @error="imgError(1)"/>
            </div>
            <div class="bundleTNimg">
               <img :src="item.imgs[2].img" @error="imgError(2)"/>
            </div>


            <div class=" has-background-coolGreen has-text-left">
                <div class="avatarTiny is-inline-block top2 left2">
                    <img :src="item.avatarImg" />
                </div>
                <div class="is-inline-block is-size-7 vTop top6 left3 has-text-dark">
                    <b>{{item.handle}}</b>
                </div>
                <div class="is-pulled-right right5 is-size-8 top5 bundleTNtimestamp has-text-dark">
                    <timeago :datetime="item.lastUpdate"></timeago>
                </div>
            </div>

            <div class="is-size-7 top-5 bundleTNdescr has-text-left posRelative has-background-dark">
                <div class="bundleTNdescriptionText"><span class="has-text-white">{{item.descr}}</span></div>
                <follow v-show="!$parent.$parent.isOwn"></follow>
            </div>
    </div>
</template>

<script>

import defImages from '../static/defimages'
import Follow from './Follow'
export default {
    components: {Follow},
    props: {item: Object},
    data: function(){
        return {
           /*  item: {
                bundleId: 24,
                listName: 'Public Bundle',
                imgs: [
                'https://i.scdn.co/image/ab67616d0000b273e5c6b875cb21fc9f0a00371f', 'https://i.scdn.co/image/ab67616d0000b273cacd7b87c756da21745e516a', 'https://i.scdn.co/image/ab67616d0000b273dbaeb558eb0749bd4e32fc8d'
                ],
                descr: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry\'s standard dummy text ever since the 1500s',
                handle: 'alezalles',
                avatarImg: 'http://digitalear.net/images/az.jpg'
            } */
        }
    },
    methods: {
        imgError: function(id){
            this.item.imgs[id].img = defImages.def;
        },
        getBundle: function(){

            if(this.$parent.$parent.handle == this.item.handle){
            
                this.$root.app.doShowModal('ModalBundle', {mCode: this.item.mCode, myBundle: this.$parent.$parent.isOwn})
               
                
                var temp = this.$route.fullPath
                if(temp[temp.length - 1] != '/')
                    temp += '/'

                var temp2 = ''
                if(temp.split('/b/').length > 1){
    
                } else if(temp.split(this.$route.params.id).length > 1 ){
                    temp2 = 'b/' + this.item.mCode
                } else {
                    temp2 = this.$root.app.$refs.routerView.handle + '/b/' + this.item.mCode
                }

                history.replaceState(
                    {},
                    null,
                    temp + temp2
                )
            } else {
                this.$router.push({name: 'profiledelegate', params: {propProfile: this.item.handle, propMCode: this.item.mCode, myBundle: this.$parent.$parent.isOwn}})
            }
        }
    }
}
</script>